import React, { useContext } from 'react';
import { Url } from '@wix/da-url';
import { SubmitFormContext } from '../../context';
import GenericErrorBanner from './_partials/GenericErrorBanner';
import ScheduledPublishBanner from './_partials/ScheduledPublishBanner';
import { DeviationSubmitPopupStoreSlice } from '../../redux/types';
import { SUBMIT_POPUP_ERROR_CODE } from '../../redux/constants';
import { useSelector } from 'react-redux';
import { getIsBusyScheduling, getScheduleTimestamp } from '../../redux/selectors';

import s from './SubmitFormBanner.scss';

export interface Props {
  error: DeviationSubmitPopupStoreSlice['error'];
}

const SubmitFormBanner: React.FC<Props> = ({ error }) => {
  const { initResponse } = useContext(SubmitFormContext)!;
  const deviation = initResponse!.deviation!;
  let banner;

  const isBusyScheduling = useSelector(getIsBusyScheduling);
  const scheduleTimestamp = useSelector(getScheduleTimestamp);

  // For this specific error we show the error banner, otherwise a toaster notification will be pushed by the saga
  if (error && error.errorCode === SUBMIT_POPUP_ERROR_CODE.ITEM_COUNT_QUOTA_LIMIT_REACHED) {
    banner = <GenericErrorBanner learnMoreUrl={Url.contactLink()} />;
  } else if (scheduleTimestamp) {
    banner = (
      <ScheduledPublishBanner
        deviation={deviation}
        timestamp={scheduleTimestamp}
        disableButtons={isBusyScheduling}
      />
    );
  }

  return banner ? <div className={s['banner']}>{banner}</div> : null;
};
SubmitFormBanner.displayName = 'SubmitFormBanner';

export default SubmitFormBanner;
